import { Scope } from '@unform/core'
import { t } from 'i18next'

import AddressFieldset from '~/components/AddressFieldset'

import { useRechargeForm } from '../../../../hooks/useRechargeForm'

const AddressSection = () => {
  const { formRef, addressStepIsValid } = useRechargeForm()

  return (
    <Scope path="billingAddress">
      <AddressFieldset
        formRef={formRef}
        title={t('rm:payment.billingAddress')}
        descriptionPanel={t('rm:payment.aditionalInfo')}
        allRequired
        isCollapsible={false}
        showBadgeValidate
        badgeIsValid={addressStepIsValid}
        autocompleteByPostalCode={false}
      />
    </Scope>
  )
}

export default AddressSection
